import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-d0363452")

_pushScopeId("data-v-d0363452")
const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-expand-lg navbar container justify-content-between"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1)
const _hoisted_3 = {
  class: "nav-link",
  href: "#",
  id: "userOption",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  d: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
}, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_9 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Verify ")
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z"
  })
], -1)
const _hoisted_12 = {
  key: 1,
  class: "dropdown-item bg-success text-white"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Verified ")
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M17 11C17.3 11 17.7 11 18 11.1V6.3L10.5 3L3 6.3V11.2C3 15.7 6.2 20 10.5 21C11.1 20.9 11.6 20.7 12.1 20.5C11.4 19.5 11 18.3 11 17C11 13.7 13.7 11 17 11M17 13C14.8 13 13 14.8 13 17S14.8 21 17 21 21 19.2 21 17 19.2 13 17 13M17 14.4C17.6 14.4 18.1 14.9 18.1 15.5C18.1 16.1 17.6 16.6 17 16.6S15.9 16.1 15.9 15.5 16.4 14.4 17 14.4M17 19.8C16.1 19.8 15.3 19.3 14.8 18.6C14.9 17.9 16.3 17.5 17 17.5S19.2 17.9 19.2 18.6C18.7 19.3 17.9 19.8 17 19.8Z"
  })
], -1)
const _hoisted_15 = {
  key: 2,
  class: "dropdown-item bg-success text-white"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Two-factor authentication is enabled ")
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M17,1H7A2,2 0 0,0 5,3V6H7V4H17V20H7V18H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M8.8,11V9.5C8.8,8.1 7.4,7 6,7C4.6,7 3.2,8.1 3.2,9.5V11C2.6,11 2,11.6 2,12.2V15.7C2,16.4 2.6,17 3.2,17H8.7C9.4,17 10,16.4 10,15.8V12.3C10,11.6 9.4,11 8.8,11M7.5,11H4.5V9.5C4.5,8.7 5.2,8.2 6,8.2C6.8,8.2 7.5,8.7 7.5,9.5V11Z"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Enable two-factor authenticator ")
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M7,1A2,2 0 0,0 5,3V7H7V4H17V20H7V17H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1H7M6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C7.31,15 8.42,14.17 8.83,13H11V15H13V13H14V11H8.83C8.42,9.83 7.31,9 6,9M6,11A1,1 0 0,1 7,12A1,1 0 0,1 6,13A1,1 0 0,1 5,12A1,1 0 0,1 6,11Z"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Bussines Profile ")
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-alt" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" My Profile & Security ")
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-columns" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fas fa-wallet" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Bank Accounts & Wallets ")
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fas fa-book" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Account Ledger ")
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "divider container" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TwoFactorAuthenticator = _resolveComponent("TwoFactorAuthenticator")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode(_component_TwoFactorAuthenticator, {
      show: _ctx.modalShow,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShow = false))
    }, null, 8, ["show"]),
    (_ctx.status == 'success')
      ? (_openBlock(), _createBlock("nav", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode(_component_router_link, { to: { name: 'Home' } }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createVNode("a", _hoisted_3, [
            _createVNode("b", null, _toDisplayString(_ctx.userProfile.firstName), 1),
            _hoisted_4,
            (!_ctx.userProfile.corporate)
              ? (_openBlock(), _createBlock("svg", _hoisted_5, [
                  _hoisted_6
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_7, [
                  _hoisted_8
                ]))
          ]),
          _createVNode("div", _hoisted_9, [
            (!_ctx.userProfile.isActive)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'verify.zero' },
                  class: "dropdown-item"
                }, {
                  default: _withId(() => [
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.userProfile.isActive)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14
                ]))
              : _createCommentVNode("", true),
            (_ctx.userProfile.isTwoFactorAuthenticationEnabled)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17
                ]))
              : _createCommentVNode("", true),
            (!_ctx.userProfile.isTwoFactorAuthenticationEnabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  class: "dropdown-item bg-primary text-white",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enable2fa()))
                }, [
                  _hoisted_18,
                  _hoisted_19
                ]))
              : _createCommentVNode("", true),
            _hoisted_20,
            (_ctx.userProfile.corporate)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: { name: 'profile.company' },
                  class: "dropdown-item"
                }, {
                  default: _withId(() => [
                    _hoisted_21,
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: { name: 'profile.my.profile' },
                  class: "dropdown-item"
                }, {
                  default: _withId(() => [
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["to"])),
            _createVNode(_component_router_link, {
              to: { name: 'Home' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_25,
                _hoisted_26
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'bank.account.list' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_27,
                _hoisted_28
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: { name: 'account.statement.report' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
              class: "dropdown-item pointer"
            }, [
              _hoisted_31,
              _hoisted_32
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_33
  ]))
})